function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import * as React from "react";
var SvgBankCardSmoll = function SvgBankCardSmoll(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 24,
    height: 16,
    rx: 2.22222,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.21631,
    y: 11.3555,
    width: 3.77247,
    height: 0.754494,
    rx: 0.377247,
    fill: "#8D92A4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.23438,
    y: 11.3555,
    width: 3.77247,
    height: 0.754494,
    rx: 0.377247,
    fill: "#8D92A4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.2891,
    y: 11.3555,
    width: 3.77247,
    height: 0.754494,
    rx: 0.377247,
    fill: "#8D92A4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.3066,
    y: 11.3555,
    width: 3.77247,
    height: 0.754494,
    rx: 0.377247,
    fill: "#8D92A4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.02686,
    cy: 5.88624,
    r: 1.88623,
    fill: "#E01420"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5542,
    cy: 5.88624,
    r: 1.88623,
    fill: "#FEE12B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.29057 7.28717C6.6729 6.94197 6.91318 6.44242 6.91318 5.88675C6.91318 5.33108 6.6729 4.83153 6.29057 4.48633C5.90825 4.83153 5.66797 5.33108 5.66797 5.88675C5.66797 6.44242 5.90825 6.94197 6.29057 7.28717Z",
    fill: "#FF8601"
  }));
};
export default SvgBankCardSmoll;